import React from 'react'

import DOMPurify from 'dompurify'

interface SafeHTMLProps {
  html: string
  className?: string
  element?: keyof JSX.IntrinsicElements
}

const SafeHTML: React.FC<SafeHTMLProps> = ({
  html,
  className,
  element: Element = 'div',
}) => {
  const sanitizedHTML = DOMPurify.sanitize(html)

  return (
    <Element
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  )
}

export default SafeHTML
